/**
 * Einfache Dubletten-Erkennung beim Anlegen einer Eisdiele (Bauphase 3):
 * Luftlinien-Abstand per Haversine-Formel. Unter ~120 m gilt eine bestehende
 * Eisdiele als möglicher Treffer — das deckt "gleiches Gebäude, leicht
 * andere Geokodierung" ab, ohne bei benachbarten, aber unterschiedlichen
 * Eisdielen falsch anzuschlagen.
 */
const ERDRADIUS_M = 6_371_000;
const SCHWELLE_M = 120;

function haversineMeter(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return ERDRADIUS_M * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export interface EisdielePosition {
  id: string;
  name: string;
  ort: string;
  lat: number;
  lng: number;
}

export function findeMoeglicheDublette(
  lat: number,
  lng: number,
  bestehende: EisdielePosition[],
): EisdielePosition | null {
  let naechste: EisdielePosition | null = null;
  let naechsteDistanz = Infinity;
  for (const e of bestehende) {
    const d = haversineMeter(lat, lng, e.lat, e.lng);
    if (d < naechsteDistanz) {
      naechsteDistanz = d;
      naechste = e;
    }
  }
  return naechste && naechsteDistanz <= SCHWELLE_M ? naechste : null;
}
